export default __webpack_public_path__ + "static/media/157.fc9b6b63.svg";